import Complaint from './complaint';
import {FormAjax} from './../../../../front/static/src/tools/form.ajax.es6';

$(document).ready(function() {
    const $form = Complaint.getForm();
    if ($form.length) {
        new FormAjax($form, (response, e) => {
            Complaint.success(response);
        }, (response, e) => {
            Complaint.error();
        });
    }

    if (Complaint.isPresent()) {
        Complaint.init();
    }
});
